import { useRef } from 'react';
import {
  ResponsiveContainer,
  StackedCarousel,
} from 'react-stacked-center-carousel';
import Icons from '../../../../../common/widgets/Icons';
import { rewriteImageUrl } from '../../../helpers';

const CardSlide = (props: { data: string[]; dataIndex: number }) => {
  const { data, dataIndex } = props;
  const imageUrl = rewriteImageUrl(data[dataIndex]);
  return (
    <div className="my-account-slide">
      <img draggable={false} src={imageUrl} alt="" />
    </div>
  );
};

interface StackedCarouselProps {
  cardsCoverUrls: string[];
}

export default function StackedCardsCarousel(
  props: Readonly<StackedCarouselProps>,
) {
  const { cardsCoverUrls } = props;
  const maxVisibleSlides = cardsCoverUrls.length == 2 ? 1 : 3;
  const respContainerRef = useRef<any>();
  return (
    <div className="mydash-cards-carousel no-select">
      <ResponsiveContainer
        carouselRef={respContainerRef}
        render={(parentWidth, carouselRef) => {
          return (
            <StackedCarousel
              ref={carouselRef}
              slideComponent={CardSlide}
              slideWidth={140}
              carouselWidth={parentWidth}
              data={cardsCoverUrls}
              currentVisibleSlide={maxVisibleSlides}
              disableSwipe={false}
              fadeDistance={0}
              maxVisibleSlide={maxVisibleSlides}
            />
          );
        }}
      />
      <a
        className="dash-carousel-nav prev no-select"
        href={void 0}
        onClick={() => {
          respContainerRef.current?.goBack();
        }}
      >
        <Icons.CarouselPrevious />
      </a>
      <a
        className="dash-carousel-nav next no-select"
        href={void 0}
        onClick={() => {
          respContainerRef.current?.goNext();
        }}
      >
        <Icons.CarouselNext />
      </a>
    </div>
  );
}
